(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-2-get-1-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('streetwear-cart-rewards')) {
    class StreetwearCartRewards extends HTMLElement {
      static drawers = new WeakMap();

      connectedCallback() {
        const drawer = this.closest('cart-drawer');
        if (drawer) StreetwearCartRewards.observe(drawer);
        this.startCountdown();
      }

      static observe(drawer) {
        if (!StreetwearCartRewards.drawers.has(drawer)) {
          const state = { earned: Number(drawer.querySelector('streetwear-cart-rewards')?.dataset.earned || 0), pending: false, celebrateUntil: 0, frame: 0, timer: 0, wasActive: false };
          state.observer = new MutationObserver(() => {
            if (state.frame) return;
            state.frame = requestAnimationFrame(() => {
              state.frame = 0;
              StreetwearCartRewards.sync(drawer, state);
            });
          });
          state.observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
          StreetwearCartRewards.drawers.set(drawer, state);
        }
      }

      disconnectedCallback() {
        clearInterval(this.countdownTimer);
      }

      static sync(drawer, state) {
        const card = drawer.querySelector('streetwear-cart-rewards');
        const earned = Number(card?.dataset.earned || 0);
        if (earned > state.earned) state.pending = true;
        if (earned < state.earned) {
          state.pending = false;
          state.celebrateUntil = 0;
        }
        state.earned = earned;
        const active = drawer.classList.contains('active');
        const justOpened = active && !state.wasActive;
        state.wasActive = active;
        if (!card) {
          try { sessionStorage.removeItem('zrex-cart-offer-countdown'); } catch {}
          return;
        }
        if ((state.pending || (justOpened && earned > 0)) && active) {
          state.pending = false;
          state.celebrateUntil = Date.now() + 4500;
          clearTimeout(state.timer);
          state.timer = setTimeout(() => StreetwearCartRewards.sync(drawer, state), 4550);
        }
        const celebrating = state.celebrateUntil > Date.now();
        if (card.classList.contains('cart-rewards--celebrating') !== celebrating) card.classList.toggle('cart-rewards--celebrating', celebrating);
        const checkout = drawer.querySelector('#CartDrawer-Checkout');
        if (checkout) {
          if (!checkout.querySelector('.cart-reward-shine')) {
            const shine = document.createElement('span');
            shine.className = 'cart-reward-shine';
            shine.setAttribute('aria-hidden', 'true');
            checkout.append(shine);
          }
          const shineActive = active && earned > 0;
          if (checkout.classList.contains('cart-reward-celebrate') !== shineActive) checkout.classList.toggle('cart-reward-celebrate', shineActive);
        }
      }

      startCountdown() {
        const row = this.querySelector('.cart-offer__deadline');
        const clock = this.querySelector('.cart-offer__clock');
        if (!row || !clock) return;
        const duration = Math.min(60, Math.max(1, Number(this.dataset.duration) || 14));
        let saved;
        try { saved = JSON.parse(sessionStorage.getItem('zrex-cart-offer-countdown')); } catch {}
        const cycle = duration * 60000;
        const valid = Number.isFinite(saved?.expiresAt) && saved.duration === duration;
        let end = valid ? saved.expiresAt : Date.now() + cycle;
        const persist = () => {
          clock.dateTime = new Date(end).toISOString();
          try { sessionStorage.setItem('zrex-cart-offer-countdown', JSON.stringify({ expiresAt: end, duration })); } catch {}
        };
        if (end <= Date.now()) end += (Math.floor((Date.now() - end) / cycle) + 1) * cycle;
        persist();
        const update = () => {
          if (end <= Date.now()) {
            end += (Math.floor((Date.now() - end) / cycle) + 1) * cycle;
            persist();
          }
          const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
          const minutes = Math.floor(seconds / 60);
          const remainder = seconds % 60;
          const value = [minutes, remainder].map(n => String(n).padStart(2, '0')).join(':');
          if (clock.textContent !== value) clock.textContent = value;
          row.hidden = false;
        };
        update();
        this.countdownTimer = setInterval(update, 1000);
      }
    }
    customElements.define('streetwear-cart-rewards', StreetwearCartRewards);
    document.querySelectorAll('cart-drawer').forEach(drawer => StreetwearCartRewards.observe(drawer));
  }
  } catch(e) { console.error(e); }
})();

})();
